<template>
  <div v-if="!allRequestComplete">
    <LoadingMask v-if="!isFromTab"/>
    <!-- 骨架屏展示 -->
    <CouponCenterSkeleton v-if="isFromTab"/>
  </div>
</template>

<script>
import LoadingMask from "@/components/loading/loading-mask";
import CouponCenterSkeleton from './couponCenterSkeleton.vue' 
export default {
  name:'MaskLoading',
  props: {
    allRequestComplete: {
      default: false,
    },
    isFromTab: {
      default: false,
    },
  },
  components: {
    LoadingMask,
    CouponCenterSkeleton
  },
};
</script>